import { Pie } from "react-chartjs-2";
import { getPieData } from "../../utils/partnershipHelpers";
import "./ProfitPie.css";

const ProfitPie = ({ stats, selectedPartner }) => {
  const data = getPieData({ stats, selectedPartner });

  if (!data) return null;

  return (
    <div className="chart-container">
      <Pie
  data={data}
  options={{
    rotation: -90, // start from left instead of top
  }}
/>
    </div>
  );
};

export default ProfitPie;